import React, { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "../services/supabase";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // User & Page State
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState("advanced");
  const [darkMode, setDarkMode] = useState(false);
  const [currentTab, setCurrentTab] = useState("Home");
  const [hideBottomNav, setHideBottomNav] = useState(false);

  // DebugPage: pageState
  const [pageState, setPageState] = useState({});
  
  // BLM Campgrounds
  const [blmCampgrounds, setBlmCampgrounds] = useState([]); // all campgrounds
  const [selectedBlmCampground, setSelectedBlmCampground] = useState(null); // single selection

  // Add Supabase session logic for user
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data?.session?.user) {
        setUser(data.session.user);
      }
    });
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
    });
    return () => listener.subscription.unsubscribe();
  }, []);

  return (
    <AppContext.Provider
      value={{
        user,
        setUser,
        email,
        setEmail,
        password,
        setPassword,
        mode,
        setMode,
        darkMode,
        setDarkMode,
        currentTab,
        setCurrentTab,
        hideBottomNav,
        setHideBottomNav,
        blmCampgrounds,
        setBlmCampgrounds,
        selectedBlmCampground,
        setSelectedBlmCampground,
        pageState,
        setPageState
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
